var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgNetRightBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "579px",
    height: "413px",
    viewBox: "0 0 579 413",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "advantage/pattern_01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "path-1",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-3",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-5",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-7",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-9",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-11",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-13",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-15",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-17",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-19",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-21",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-23",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-25",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-27",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-29",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-31",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-33",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-35",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-37",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-39",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-41",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-43",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-45",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-47",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-49",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-51",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-53",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-55",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-57",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-59",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-61",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-63",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-65",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-67",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-69",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-71",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-73",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-75",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-77",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-79",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-81",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-83",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-85",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-87",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-89",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-91",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-93",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-95",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-97",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-99",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-101",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cutimg",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Advantage",
    transform: "translate(-1341.000000, -2147.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1341.000000, 2147.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Clip-152",
    fill: "#00A3E0",
    points: "68.4432584 294.542069 0 413 579 413 579 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pattern"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.6329228,
    y1: -280.156229,
    x2: 34.6329228,
    y2: 968.768962,
    id: "Stroke-1",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.763927,
    y1: -280.156229,
    x2: 90.763927,
    y2: 968.768962,
    id: "Stroke-4",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.108866,
    y1: -280.156229,
    x2: 145.108866,
    y2: 968.768962,
    id: "Stroke-7",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.451095,
    y1: -280.156229,
    x2: 199.451095,
    y2: 968.768962,
    id: "Stroke-10",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 253.793596,
    y1: -280.156229,
    x2: 253.793596,
    y2: 968.768962,
    id: "Stroke-13",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-17"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308.135825,
    y1: -280.156229,
    x2: 308.135825,
    y2: 968.768962,
    id: "Stroke-16",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.478325,
    y1: -280.156229,
    x2: 362.478325,
    y2: 968.768962,
    id: "Stroke-19",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-23"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.823264,
    y1: -280.156229,
    x2: 416.823264,
    y2: 968.768962,
    id: "Stroke-22",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-26"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 471.165494,
    y1: -280.156229,
    x2: 471.165494,
    y2: 968.768962,
    id: "Stroke-25",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-30"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-29"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 525.507994,
    y1: -280.156229,
    x2: 525.507994,
    y2: 968.768962,
    id: "Stroke-28",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-20)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-33"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-32"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -382.523603,
    y1: 384.770875,
    x2: 699.910011,
    y2: 1009.23212,
    id: "Stroke-31",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-22)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-36"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-35"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -355.349779,
    y1: 337.74345,
    x2: 727.081126,
    y2: 962.204691,
    id: "Stroke-34",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-24)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-39"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-38"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -328.178664,
    y1: 290.719003,
    x2: 754.25224,
    y2: 915.180244,
    id: "Stroke-37",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-26)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-42"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-41"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -301.007549,
    y1: 243.691848,
    x2: 781.423355,
    y2: 868.15309,
    id: "Stroke-40",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-45"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-30",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-44"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -273.836164,
    y1: 196.667402,
    x2: 808.594741,
    y2: 821.128643,
    id: "Stroke-43",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-30)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-48"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-32",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-47"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -246.665049,
    y1: 149.639977,
    x2: 835.765855,
    y2: 774.101218,
    id: "Stroke-46",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-32)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-51"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-34",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-50"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -219.493934,
    y1: 102.612822,
    x2: 862.93697,
    y2: 727.076771,
    id: "Stroke-49",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-34)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-54"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-36",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-53"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -192.32282,
    y1: 55.5883754,
    x2: 890.110794,
    y2: 680.049617,
    id: "Stroke-52",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-36)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-57"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-38",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-37"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-56"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -165.151705,
    y1: 8.56122113,
    x2: 917.281909,
    y2: 633.022463,
    id: "Stroke-55",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-38)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-60"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-40",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-39"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-59"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -137.980319,
    y1: -38.4634965,
    x2: 944.453295,
    y2: 585.997745,
    id: "Stroke-58",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-40)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-63"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-42",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-62"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -110.809205,
    y1: -85.4906508,
    x2: 971.624409,
    y2: 538.970591,
    id: "Stroke-61",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-42)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-66"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-44",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-65"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -83.6380899,
    y1: -132.517805,
    x2: 998.795524,
    y2: 491.946144,
    id: "Stroke-64",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-44)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-69"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-46",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-68"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -56.4642658,
    y1: -179.542252,
    x2: 1025.96664,
    y2: 444.91899,
    id: "Stroke-67",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-46)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-72"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-48",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-71"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -29.2931511,
    y1: -226.569677,
    x2: 1053.13775,
    y2: 397.891565,
    id: "Stroke-70",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-48)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-75"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-50",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-49"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-74"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -2.12203634,
    y1: -273.594124,
    x2: 1080.30887,
    y2: 350.867118,
    id: "Stroke-73",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-50)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-78"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-52",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-77"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.0493493,
    y1: -320.621278,
    x2: 1107.48025,
    y2: 303.839963,
    id: "Stroke-76",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-52)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-81"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-54",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-80"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.220464,
    y1: -367.645996,
    x2: 1134.65137,
    y2: 256.815246,
    id: "Stroke-79",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-54)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-84"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-56",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-55"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-83"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.3915787,
    y1: -414.67315,
    x2: 1161.82519,
    y2: 209.788092,
    id: "Stroke-82",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-56)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-87"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-58",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-86"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.562693,
    y1: -461.700304,
    x2: 1188.99631,
    y2: 162.760937,
    id: "Stroke-85",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-58)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-90"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-60",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-59"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-89"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.733808,
    y1: -508.724751,
    x2: 1216.16742,
    y2: 115.73649,
    id: "Stroke-88",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-60)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-93"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-62",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-92"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1107.47998,
    y1: 384.770875,
    x2: 25.0490784,
    y2: 1009.23212,
    id: "Stroke-91",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-62)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-96"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-64",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-95"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1080.30887,
    y1: 337.74345,
    x2: -2.12203634,
    y2: 962.204691,
    id: "Stroke-94",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-64)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-99"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-66",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-65"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-98"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1053.13775,
    y1: 290.719003,
    x2: -29.2931511,
    y2: 915.180244,
    id: "Stroke-97",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-66)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-102"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-68",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-67"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-101"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1025.96637,
    y1: 243.691848,
    x2: -56.4645367,
    y2: 868.15309,
    id: "Stroke-100",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-68)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-105"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-70",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-104"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 998.795253,
    y1: 196.667402,
    x2: -83.6383609,
    y2: 821.128643,
    id: "Stroke-103",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-70)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-108"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-72",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-71"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-107"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 971.624138,
    y1: 149.639977,
    x2: -110.809476,
    y2: 774.101218,
    id: "Stroke-106",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-72)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-111"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-74",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-110"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 944.453024,
    y1: 102.612822,
    x2: -137.98059,
    y2: 727.076771,
    id: "Stroke-109",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-74)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-114"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-76",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-113"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 917.281909,
    y1: 55.5883754,
    x2: -165.151705,
    y2: 680.049617,
    id: "Stroke-112",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-76)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-117"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-78",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-116"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 890.110523,
    y1: 8.56122113,
    x2: -192.323091,
    y2: 633.022463,
    id: "Stroke-115",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-78)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-120"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-80",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-119"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 862.936699,
    y1: -38.4634965,
    x2: -219.494205,
    y2: 585.997745,
    id: "Stroke-118",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-80)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-123"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-82",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-122"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 835.765584,
    y1: -85.4906508,
    x2: -246.66532,
    y2: 538.970591,
    id: "Stroke-121",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-82)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-126"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-84",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-125"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 808.59447,
    y1: -132.517805,
    x2: -273.836435,
    y2: 491.946144,
    id: "Stroke-124",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-84)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-129"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-86",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-128"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 781.423355,
    y1: -179.542252,
    x2: -301.007549,
    y2: 444.91899,
    id: "Stroke-127",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-86)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-132"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-88",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-87"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-131"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 754.25224,
    y1: -226.569677,
    x2: -328.178664,
    y2: 397.891565,
    id: "Stroke-130",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-88)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-135"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-90",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-134"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 727.080855,
    y1: -273.594124,
    x2: -355.35005,
    y2: 350.867118,
    id: "Stroke-133",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-90)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-138"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-92",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-91"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-137"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 699.90974,
    y1: -320.621278,
    x2: -382.523874,
    y2: 303.839963,
    id: "Stroke-136",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-92)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-141"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-94",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-93"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-140"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 672.738625,
    y1: -367.645996,
    x2: -409.694989,
    y2: 256.815246,
    id: "Stroke-139",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-94)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-144"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-96",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-95"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-143"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 645.567511,
    y1: -414.67315,
    x2: -436.866103,
    y2: 209.788092,
    id: "Stroke-142",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-96)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-147"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-98",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-97"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-146"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 618.396396,
    y1: -461.700304,
    x2: -464.037218,
    y2: 162.760937,
    id: "Stroke-145",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-98)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-150"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-100",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-149"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 591.22501,
    y1: -508.724751,
    x2: -491.208604,
    y2: 115.73649,
    id: "Stroke-148",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-100)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-102",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-152"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-151",
    stroke: "#10069F",
    strokeWidth: 0.5264,
    mask: "url(#mask-102)",
    points: "-262.463816 968.767337 987.42426 968.767337 987.42426 -280.157853 -262.463816 -280.157853"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNetRightBlue);
export default __webpack_public_path__ + "static/media/img_net_right_blue.239deb2b50739d9683ffb53a0908242e.svg";
export { ForwardRef as ReactComponent };